/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_DaysInputs */

const en_us2_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length`)
};

const pt_br2_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

const es_419_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const pt_pt2_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

const fr_fr2_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const de_de2_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_it2_clubs_field_days = /** @type {(inputs: Clubs_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

/**
* | output |
* | --- |
* | "Length" |
*
* @param {Clubs_Field_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_days = /** @type {((inputs?: Clubs_Field_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_days(inputs)
	if (locale === "es-419") return es_419_clubs_field_days(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_days(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_days(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_days(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_days(inputs)
	return en_us2_clubs_field_days(inputs)
});
export { clubs_field_days as "clubs.field_days" }